import { CategorizedDocumentsList } from "@/components/documents/CategorizedDocumentsList"
import { useDocuments } from "@/components/documents/context/DocumentsProvider"
import { FormHeader } from "@/components/form-elements/FormHeader"
import { Card, CardContent } from "@/components/ui/card"

const orgDocTypes = ["Articles of Incorporation", "EIN Letter"]
const chequeDocTypes = ["Banking Documentation"]
const ownerDocTypes = ["Driver's License #1", "Driver's License #2"]

export function BusinessDocumentsCard() {
  const { categorized } = useDocuments()

  const businessDocs = categorized.filter((doc) => doc.category === "business")
  const orgDocs = businessDocs.filter((doc) =>
    orgDocTypes.includes(doc.typeName ?? ""),
  )
  const chequeDocs = businessDocs.filter((doc) =>
    chequeDocTypes.includes(doc.typeName ?? ""),
  )
  const ownerDocs = businessDocs.filter((doc) =>
    ownerDocTypes.includes(doc.typeName ?? ""),
  )
  return (
    <Card className="w-full border-0 shadow-sm">
      <CardContent>
        <FormHeader title="Business Documents" />
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <CategorizedDocumentsList
            documents={orgDocs}
            title="Organization Documents"
          />
          <CategorizedDocumentsList
            documents={chequeDocs}
            title="Void Cheque"
          />
          <CategorizedDocumentsList documents={ownerDocs} title="Owner ID" />
        </div>
      </CardContent>
    </Card>
  )
}
